import { EditorObject } from 'utils/responsiveTypes'
import getDeviceObject from 'utils/getDeviceObject'
import { getParentScreen } from 'utils/positioning'
import { getDeviceType } from '@adalo/utils'
import getObject from './objects/getObject'
import InstructionState from './types/InstructionState'

export interface SelectionBounds {
  left: number
  right: number
  top: number
  bottom: number
}

export const defaultBounds = {
  left: Number.MAX_SAFE_INTEGER,
  right: Number.MIN_SAFE_INTEGER,
  top: Number.MAX_SAFE_INTEGER,
  bottom: Number.MIN_SAFE_INTEGER,
}

export const getSelectionBounds = (
  state: InstructionState,
  selectionIds: string[]
): SelectionBounds => {
  if (selectionIds.length < 1) {
    return defaultBounds
  }

  const { list, pathMap } = state
  const selection = selectionIds.map(id => getObject(list, pathMap, id))

  const getSelectionBoundsReducer = (
    previousValue: SelectionBounds,
    current: EditorObject
  ): SelectionBounds => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const parent = getParentScreen(list, pathMap, current.id)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const device = getDeviceType(parent.width as number)
    const currentValue = getDeviceObject(current, device)

    const currentRight = currentValue.x + currentValue.width
    const currentBottom = currentValue.y + currentValue.height

    return {
      left: Math.min(previousValue.left, currentValue.x),
      right: Math.max(previousValue.right, currentRight),
      top: Math.min(previousValue.top, currentValue.y),
      bottom: Math.max(previousValue.bottom, currentBottom),
    }
  }

  return selection.reduce(getSelectionBoundsReducer, defaultBounds)
}
